var ready = require('./ready.js');

ready(function() {
    function setTextOnModal() {
        var text = document.querySelectorAll(this.dataset.text);
        var textInput = document.querySelectorAll('#' + this.dataset.target + ' .question-text');

        if (text.length == 1 && textInput.length == 1) {
            textInput[0].value = text[0].value;
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            textInput[0].dispatchEvent(event);
        }
    }

    var elements = document.querySelectorAll('.question-set-text');

    Array.prototype.forEach.call(elements, function(el) {
        el.addEventListener('click', setTextOnModal);
    });

    var questionInput = document.querySelector('#pre-question-text');
    questionInput && questionInput.addEventListener('keyup', function(e) {
        if (e.keyCode == 13) {
            var evt = document.createEvent('MouseEvents');
            evt.initEvent('click', true, false);
            document.querySelector('.question-set-text').dispatchEvent(evt);
        }
    });
});
